<div class="d-flex flex-row text-small">
  @for (tab of tabs; track $index) {
    <div
      class="tab"
      [class.active]="tab.name === (selected$ | async)"
      (click)="onSelect(tab.name)"
      (keypress)="onSelect(tab.name)"
      tabindex="0"
    >
      <span class="fs-6">{{ tab.name }}</span>
    </div>
  }
</div>
